var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaiwan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_17231)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_17231",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_17231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2819 3H3V23H37.2819V3Z",
    fill: "#D10E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9983 3H3V12.9967H17.9983V3Z",
    fill: "#1C2666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4968 7.99498L10.4992 11.7446L9.5015 7.99498L10.4992 4.2454M10.4992 8.99933L14.2487 8.00168L10.4992 7.00402L6.74957 8.00168",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3629 8.49716L8.62438 11.2424L9.63543 7.4928L12.374 4.74757M9.997 8.86542L13.7466 9.87646L11.0014 7.13793L7.25177 6.12688",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0014 8.86542L7.25177 9.87646L9.997 7.13793L13.7466 6.12688M9.63543 8.49716L12.374 11.2424L11.3629 7.4928L8.62438 4.74757",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4992 5.87244C11.6709 5.87244 12.6217 6.82323 12.6217 7.99497C12.6217 9.16672 11.6709 10.1175 10.4992 10.1175C9.32743 10.1175 8.37665 9.16672 8.37665 7.99497C8.37665 6.82323 9.32743 5.87244 10.4992 5.87244Z",
    fill: "#1C2666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4991 6.12019C11.537 6.12019 12.3739 6.95715 12.3739 7.99498C12.3739 9.03281 11.537 9.86977 10.4991 9.86977C9.46132 9.86977 8.62436 9.03281 8.62436 7.99498C8.62436 6.96384 9.46132 6.12019 10.4991 6.12019Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_17231",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_17231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_17231",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaiwan);
export default __webpack_public_path__ + "static/media/Taiwan.4d9d0b4fa133f450b85b6cea79d08ce1.svg";
export { ForwardRef as ReactComponent };